import { Component } from '@angular/core';
import { KirokuMenu } from '@app/models/record.model';
import { User } from '@app/models/user.model';
import { StorageEnum } from '@app/shared/enum/storage';
import { OpenHandler } from '@app/store/modal/modal.classes';
import { SetKirokuSetting } from '@app/store/record/record.classes';
import { RecordSelectors } from '@app/store/record/record.selectors';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import * as moment from 'moment';
import { RecordListBase } from '../record-based/record-list-based.component';
import { RouteCondition, RouteOutlet } from '@app/shared/enum/route';
import { KirokuSetting } from '@app/models/record-settig.model';
import { ConfirmType } from '@app/shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-record-kids',
  templateUrl: './record-kids.component.html',
  styleUrls: ['./record-kids.component.scss'],
})
export class RecordKidsComponent extends RecordListBase {
  _kensakuHidden = this.currentMenu == KirokuMenu.KIROKUKENSAKU;

  get visible() {
    if (this._kensakuHidden) return false;
    return true;
  }

  // getter-setter
  get settingState() {
    return this.store.selectSnapshot(RecordSelectors.setting);
  }

  override get screenName() {
    try {
      const { daicds } = this.config;
      if (this.menuConfig.type === KirokuMenu.HITORIBUNNO && daicds?.length && daicds[0]) {
        const user = this.userList.find(x => x.daicd === (daicds[0] || ''));
        return `${user?.name}様の記録`
      }
      return super.screenName;
    } catch (error) {
      return super.screenName;
    }


  }

  get isPickup() {
    return this.currentMenu === KirokuMenu.MOUSHIOKURI
  }

  get menuList() {
    return this.store.selectSnapshot(SettingSelectors.menuList);
  }

  override get currentMenu(): string {
    return localStorage.getItem(StorageEnum.MENU_ITEM) || KirokuMenu.EMPTY;
  }

  get isDev() {
    return sessionStorage.getItem('dev') == '1'
  }
  
  handleDialogOpen() {
    this.store.dispatch(new OpenHandler());
  }

  protected override initConstructor(): void {
    super.initConstructor();

  }

  override async renderContents(isIntersecting: boolean) {
    this.vcRef.clear();
    const isRouteCondition = this.routeStateCondition !== this.routeCondition.LIST;
    if (isRouteCondition || this.isFetching || this.isLastPage) return;
    this.page += 1;
    await this.getList();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.currentMenu === KirokuMenu.KIROKUKENSAKU && this.config.isInit && this.routeStateCondition === RouteCondition.LIST) {
      this._kensakuHidden = true;
      this.handleOpenDisplaySetting();
    } else {
      this._kensakuHidden = false;
    }
  }

  override handleOpenDisplaySetting() {
    this.routeControl.addSignature(this.menuSignature).then(() => {
      setTimeout(() => {
        this.openDisplaySetting().then(() => { this._kensakuHidden = false; })
      }, 20)
    });
  }

  private emptySearchAnnounce() {
    if (this.currentMenu !== KirokuMenu.KIROKUKENSAKU || this.config.isInit) return;
    const data = {
      cancelText: '',
      excuteText: '閉じる',
      content: `<p>該当する結果はありません</p>`,
      style: {
        'text-align': 'center'
      },
      type: ConfirmType.STACK_BTN

    };
    this.dialog.confirm(data);
  }

  override dataConvert(data: any) {
    if (data.length === 0) {
      if (this.page === 1) {
        this.emptySearchAnnounce();
      }
      this.page = -1;
      this.lazySpinner = false;
      return;
    }
    let filterData: any[] = [];
    const daiData = this.getUniqueObjcdWithNames(data) as any[];
    filterData = daiData.map(dai => {
      const daiFilter = data.filter((x: any) => x.objcd === dai.objcd);
      const group = this.getUniqueDatedWithNames(daiFilter).sort((a, b) => moment(b.date).diff(a.date));
      return {
        ...dai,
        notes: group
      }
    });
    if (this.page > 1 && this.renderData.length > 0) {
      filterData = this.mergeByObjcd([
        ...this.renderData, ...filterData
      ]);
    }
    if (this.currentMenu === KirokuMenu.GYOUMURENRAKU) {
      filterData.sort((a, b) => { return Number(a.objcd) - Number(b.objcd) }) || [];
    }
    this.renderData = filterData;
  }

  public override onUserChange(user: User) {
    const _config = { ... this.config };
    if (user && this.config) {
      _config.daicds = [user.daicd];
      this.renderData = [];
      this.page = 1;
      this.lastNoteValue = null;
      this.store.dispatch(new SetKirokuSetting(_config));
      this.getList();
    }

  }
  
  override rawConfigHandler(): KirokuSetting | null {
    try {
      // new
      this.getProfile();
      const timeSpan = this.menuConfig.initDaySpan;
      const pickupFlag = false;
      const defaultConfig = this.defaultKirokuSetting({ pickupFlag, timeSpan, screen: this.currentMenu });
      if (this.config.screen !== this.currentMenu) {
        return defaultConfig;
      }
      return this.isRefresh ? (this.config || defaultConfig) : defaultConfig;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  create() {
    const { daicds } = this.config;
    this.router.navigate(
      ['', { outlets: { [RouteOutlet.EDIT]: 'user-record-select' } }],
      { 
        queryParams: { user: this.isSingleUser && daicds && daicds.length > 0 ? daicds[0] : null }, 
        queryParamsHandling: 'merge' 
      }
    );
  }
}
